import React from 'react';
import icons from '../../../../shared/assets/icons/redesign';

const { Check } = icons;

import './CommunityLoginPopupContent.scss';

export default function CommunityLoginPopupContent({
  onClose,
  loginUrl,
  signupUrl
}) {
  return (
    <>
      <div className="popup-header">
        <h4 className="communityLoginPopupContent-title">Account nodig</h4>

        <button className="popup-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="popup-body">
        <p className="communityLoginPopupContent-text">
          Om de toegang te krijgen tot de community heb je een account nodig.
        </p>

        <ul className="popup-list">
          <li className="communityLoginPopupContent-list-item">
            <span className="communityLoginPopupContent-icon-wrap">
              <Check className="communityLoginPopupContent-icon" />
            </span>
            Word lid van jouw geboortegroep
          </li>

          <li className="communityLoginPopupContent-list-item">
            <span className="communityLoginPopupContent-icon-wrap">
              <Check className="communityLoginPopupContent-icon" />
            </span>
            Maak onderwerpen aan en reageer op elkaar
          </li>

          <li className="communityLoginPopupContent-list-item">
            <span className="communityLoginPopupContent-icon-wrap">
              <Check className="communityLoginPopupContent-icon" />
            </span>
            Maak nieuwe vriendinnen
          </li>

          <li className="communityLoginPopupContent-list-item">
            <span className="communityLoginPopupContent-icon-wrap">
              <Check className="communityLoginPopupContent-icon" />
            </span>
            Stel je vragen aan ervaringsdeskundigen
          </li>

          <li className="communityLoginPopupContent-list-item">
            <span className="communityLoginPopupContent-icon-wrap">
              <Check className="communityLoginPopupContent-icon" />
            </span>
            Alle voordelen van zwangerenportaal.nl
          </li>
        </ul>

        <a
          rel="noopener noreferrer"
          className="popup-button popup-button-secondary"
          href={signupUrl}
        >
          Account aanmaken
        </a>

        <a
          rel="noopener noreferrer"
          className="popup-button popup-button-primary"
          href={loginUrl}
        >
          Inloggen
        </a>
      </div>
    </>
  );
}
